import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'

import AuthTemplateWrapper from 'components/blocks/auth/AuthTemplateWrapper'
import LoginForm from 'components/blocks/auth/LoginForm'
import {Col, Container, Row} from 'components/elements/grid'
import {posthogTrack} from 'src/utils'

import s from './TemplateLogin.module.scss'
const cx = cn.bind(s)

interface ITemplateLoginProps {
	className?: string
}

const TemplateLogin: FC<ITemplateLoginProps> = ({className}) => {
	useEffect(() => {
		posthogTrack('Login page opened')
	}, [])

	return (
		<AuthTemplateWrapper className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col md={{offset: 2, span: 8}} lg={{offset: 3, span: 6}} xl={{offset: 4, span: 4}}>
						<LoginForm />
					</Col>
				</Row>
			</Container>
		</AuthTemplateWrapper>
	)
}

TemplateLogin.displayName = 'TemplateLogin'

export default TemplateLogin
